module.exports = __webpack_public_path__ + "static/media/software.17f465b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/software.jpg
// module id = 489
// module chunks = 0